import {
  IconCircleCheck,
  IconCircleX,
  IconClock
} from '@tabler/icons-react';

export const getStatusBadge = (status) => {
  const statusValue = status || 'unknown';
  switch (statusValue) {
    case 'online':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-500/20 text-green-500"><IconCircleCheck className="w-3 h-3 mr-1" />Онлайн</span>;
    case 'offline':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-500/20 text-red-500"><IconCircleX className="w-3 h-3 mr-1" />Офлайн</span>;
    case 'maintenance':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-500/20 text-yellow-500"><IconClock className="w-3 h-3 mr-1" />Обслуживание</span>;
    default:
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-500/20 text-gray-500">{statusValue}</span>;
  }
};

export const formatPercentage = (value) => {
  return (value || 0).toFixed(1);
};

export const formatNodeName = (node) => {
  return node.name || 'Неизвестная нода';
};

export const formatNodeLocation = (node) => {
  return node.location || 'Неизвестная локация';
};

export const formatNodeHost = (node) => {
  return `${node.host || 'N/A'}:${node.port || 'N/A'}`;
};